document.addEventListener("DOMContentLoaded", function () {
    let container = document.querySelector(".recommend_list[data-product-handle]");
    if (!container) return;

    let currentHandle = container.dataset.productHandle;
    const storageLimit = 10;
    const showLimit = parseInt(container.dataset.viewedProducts) || 3;

    let titleSup = container.closest('.shopify-section').querySelector(".title_container sup");

    let viewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
    viewed = viewed.filter(Boolean);
    viewed = [currentHandle, ...viewed.filter(h => h !== currentHandle)];
    viewed = viewed.slice(0, storageLimit);
    localStorage.setItem("recentlyViewed", JSON.stringify(viewed));

    let showViewed = [];
    const lastBlock = viewed.slice(-showLimit);

    if (lastBlock.includes(currentHandle)) {
        const idx = viewed.indexOf(currentHandle) + 1;
        showViewed = viewed.slice(idx, idx + showLimit).filter(h => h !== currentHandle);
        if (showViewed.length < showLimit) {
            const needed = showLimit - showViewed.length;
            showViewed = showViewed.concat(viewed.slice(0, needed).filter(h => h !== currentHandle));
        }
    } else {
        showViewed = viewed.filter(h => h !== currentHandle).slice(0, showLimit);
    }

    if (showViewed.length === 0) {
        container.closest('.shopify-section').style.display = "none";
        return;
    }

    if (titleSup) {
        titleSup.textContent = `[${showViewed.length}]`;
    }

    showViewed.forEach(handle => {
        fetch(`/products/${handle}.js`)
            .then(res => res.json())
            .then(product => fetch(`/products/${product.handle}?view=recently-viewed-card`))
            .then(r => r.text())
            .then(html => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                const card = tempDiv.querySelector('.recommend_list-item');
                if (card) {
                    container.insertAdjacentElement("beforeend", card);
                    initGalleryCardAnimations(card);
                }
            })
            .catch(err => console.error("Error loading product:", err));
    });

    function initGalleryCardAnimations(card) {
        if (!card) return;

        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(Draggable, InertiaPlugin);

        const dataImages = document.querySelectorAll("img[data-src], [data-srcset]");
        dataImages.forEach(img => {
            if (img.getAttribute("data-src")) img.setAttribute("src", img.getAttribute("data-src"));
            if (img.getAttribute("data-srcset")) img.setAttribute("srcset", img.getAttribute("data-srcset"));
            img.onload = () => {
                img.removeAttribute("data-src");
                img.removeAttribute("data-srcset");
            };
        });

        ScrollTrigger.create({
            trigger: card,
            start: "top bottom",
            scrub: true,
            once: true,
            onEnter: () => card.classList.add("animate"),
            onEnterBack: () => card.classList.add("animate")
        });

        initCursor();
    }

    function initCursor(){
        var cursorButtonContainers = $("[data-cursor-button-container]");

        function initCursorPos(e, el, button) {
            var cursorPosX = e.clientX;
            var cursorPosY = e.clientY;
            var width = button.width();
            var height = button.height();
            var scrollTop = $(document).scrollTop();
            var boxLeft = el[0].getBoundingClientRect().left;
            var boxTop = el[0].getBoundingClientRect().top;
            var boxBottom = el[0].getBoundingClientRect().bottom;
            var boxRight = el[0].getBoundingClientRect().right;// eslint-disable-next-line no-nested-ternary
            button.css("left", cursorPosX - width / 2 <= boxLeft ? 0 : cursorPosX + width / 2 >= boxRight ? boxRight - width - boxLeft : cursorPosX - width / 2 - boxLeft + "px");// eslint-disable-next-line no-nested-ternary
            button.css("top", cursorPosY - height / 2 <= boxTop ? 0 : cursorPosY + height / 2 >= boxBottom ? boxBottom - boxTop - height : cursorPosY - boxTop - height / 2 + "px");
            button.css("bottom", "unset")
        }

        if (cursorButtonContainers.length) {
            cursorButtonContainers.each(function (i, elem) {
                var button = $(elem).find("[data-cursor-button]");
                var el = $(elem);
                var all = $(elem).find(".shopnow_button *");
                elem.addEventListener("mousemove", function (e) {
                    initCursorPos(e, el, button)
                });
                elem.addEventListener("mouseenter", function (e) {
                    all.css("opacity", 1)
                });
                elem.addEventListener("mouseleave", function (e) {
                    all.css("opacity", 0)
                })
            })
        }

        function getTypeCursorBACK() {
            const cursor = document.getElementById("cursor");
            const link = document.querySelectorAll('a:not([data-fancybox]), button, .btn, .checkbox, .cursor-pointer, .select2, input, textarea, select, .product_form-dropdown-list-item, .count_input-inc, .count_input-dec, .filter-tag');
            const linkZoom = document.querySelectorAll('[data-fancybox]');
            const slider = document.querySelectorAll('.slider-drag');
            const sliderDragView = document.querySelectorAll('.slider-drag .image_frame');
            const sliderScrollView = document.querySelectorAll('.gallery_list');
            const sliderView = document.querySelectorAll('.collections_page .gallery_card .image_frame');
            link.forEach(function (item) {
                item.addEventListener( 'mouseenter', function (e) {
                    if (item.nextElementSibling && item.nextElementSibling.classList.contains('shopnow_button-wrap') || item.querySelector('.shopnow_button-wrap')) {
                        cursor.classList.add( 'is-button' );
                        if (item.closest('.image_container') || item.closest('.gallery_card-body')) {
                            cursor.classList.add("hidden");
                        }
                    } else {
                        cursor.classList.add( 'is-link' );
                    }
                });
                item.addEventListener( 'mouseleave', function (e) {
                    if (item.nextElementSibling && item.nextElementSibling.classList.contains('shopnow_button-wrap') || item.querySelector('.shopnow_button-wrap')) {
                        cursor.classList.remove( 'is-button' );
                        if (item.closest('.image_container') || item.closest('.gallery_card-body')) {
                            cursor.classList.remove("hidden");
                        }
                    } else {
                        cursor.classList.remove( 'is-link' );
                    }
                });
            });
            slider.forEach(function (item) {
                item.addEventListener( 'mouseenter', function (e) {
                    cursor.classList.add( 'is-slider' );
                });
                item.addEventListener( 'mouseleave', function (e) {
                    cursor.classList.remove( 'is-slider' );
                });
            });
            sliderScrollView.forEach(function (item) {
                item.addEventListener( 'mouseenter', function (e) {
                    cursor.classList.remove( 'is-link' );
                    cursor.classList.remove( 'is-slider' );
                    cursor.classList.add( 'is-slider-scroll' );
                });
                item.addEventListener( 'mouseleave', function (e) {
                    cursor.classList.remove( 'is-slider-scroll' );

                });
            });
            sliderDragView.forEach(function (item) {
                item.addEventListener( 'mouseenter', function (e) {
                    cursor.classList.remove( 'is-link' );
                    cursor.classList.remove( 'is-slider' );
                    cursor.classList.add( 'is-slider-view' );
                });
                item.addEventListener( 'mouseleave', function (e) {
                    cursor.classList.add( 'is-slider' );
                    cursor.classList.remove( 'is-slider-view' );
                });
            });
            sliderView.forEach(function (item) {
                item.addEventListener( 'mouseenter', function (e) {
                    cursor.classList.remove( 'is-link' );
                    cursor.classList.add( 'is-slider-view' );
                });
                item.addEventListener( 'mouseleave', function (e) {
                    cursor.classList.remove( 'is-slider-view' );
                });
            });
            linkZoom.forEach(function (item) {
                item.addEventListener( 'mouseenter', function (e) {
                    cursor.classList.add( 'is-zoom' );
                });
                item.addEventListener( 'mouseleave', function (e) {
                    cursor.classList.remove( 'is-zoom' );
                });
            });
        }
        getTypeCursorBACK();
        initAOS();
    }
});
